import React from 'react'
import { withRouter } from 'react-router-dom'
import { Container, Header, Wrapper } from '../../components_renew/Layout'
// import xibei_imgBg1 from '../../assets/xibei/happy_friday/bg_01.jpg'
// import xibei_imgBg2 from '../../assets/xibei/happy_friday/bg_02.jpg'
import imgBg1 from '../../assets/xiniu/happy_friday/bg_01.jpg'
import imgBg2 from '../../assets/xiniu/happy_friday/bg_02.jpg'
import imgCard1 from '../../assets/xiniu/integral_go/c_01.png'
import imgCard2 from '../../assets/xiniu/integral_go/c_02.png'
import imgCard3 from '../../assets/xiniu/integral_go/c_03.png'
import api from '../../api'
import { handleCatch, postMessage } from '../../utils'

const assets = {
  bg1: '',
  bg2: '',
  card1: imgCard1,
  card2: imgCard2,
  card3: imgCard3,
}

switch (process.env['REACT_APP_CHANNEL']) {
  // case 'xibei':
  //   assets.bg1 = xibei_imgBg1
  //   assets.bg2 = xibei_imgBg2
  //   break
  default:
    // xiniu
    assets.bg1 = imgBg1
    assets.bg2 = imgBg2
}

@withRouter
class IntegralGo extends React.PureComponent {
  state = {
    amount: 0,
    integral: 0,
    success: false,
  }

  componentDidMount () {
    document.title = '快乐星期五'
    window.toast.loading()
    api.integral.fetchUserIntegralToday()
      .then(res => {
        window.toast.hide()
        this.setState({ success: true })
        if (res > 0) {
          this.setState({
            integral: res,
            amount: Number((res / 10).toFixed(1))
          })
        }
      })
      .catch(handleCatch)
  }

  render () {
    const { withHeader } = this.props
    const { amount, integral } = this.state
    return <Container>
      {withHeader ? <Header>活动</Header> : null}
      <Wrapper>
        <img className='events-bg' src={assets.bg1} alt=''/>
        <div className={'events-card'} style={{ padding: '0 2rem' }}>
          <img className={'events-card__item'} src={assets.card1} alt=''/>
          <div className={'events-card__text events-card--primary'} style={{ fontSize: 12 }}>已领取 {integral} 积分
          </div>
          <img className={'events-card__item'} src={assets.card2} alt=''/>
          <div className={'events-card__text events-card--primary'}>可兑换 {amount} 元现金券</div>
          <img className={'events-card__item'} src={assets.card3} alt='' onClick={this.onBtnClick}/>
        </div>
        <img className='events-bg' src={assets.bg2} alt=''/>
      </Wrapper>
    </Container>
  }

  onBtnClick = () => {
    postMessage({
      type: window.POST_TYPE.INTEGRAL
      // type: 'integral'
    })
  }
}

export default IntegralGo
